import React from 'react'
import PropTypes from 'prop-types'
import AnimateChildren from './AnimateChildren'

/**
 * A wrapper component that animates fadeIn on it's children
 */

function FadeIn (props) {
  const defaultStyles = {
    transition: `opacity ${props.duration}ms ease`,
    opacity: 0
  }

  const transitionStyles = {
    entering: { opacity: 0 },
    entered: { opacity: 1 },
    exiting: { opacity: 0 },
    exited: { opacity: 0 }
  }

  return React.createElement(
    AnimateChildren,
    {
      transitionStyles: transitionStyles,
      defaultStyles: defaultStyles,
      ...props
    })
}

FadeIn.propTypes = {
  /**
     * Show the component; triggers the enter or exit states
     */
  in: PropTypes.any,
  /**
     * unmountOnExit, unmounts the component when the exit animation finishes (default true)
     */
  unmountOnExit: PropTypes.bool,
  /**
     * How long the animation should last
     */
  duration: PropTypes.number
}

export default FadeIn
